import script from "./EditLocation.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditLocation.vue?vue&type=script&setup=true&lang=ts"

import "./EditLocation.vue?vue&type=style&index=0&id=29256da6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29256da6"]])

export default __exports__